import { Button, Typography } from "@mui/material";

export default function NavBar() {
    return (
        <div className="NavBar">
            <div className="NavLinks">
                <Button color="secondary" size="large">
                    <Typography variant="h6">
                        <b>QU</b>MLG
                    </Typography>
                </Button>
                <Button href="#how_it_works" size="large" color="secondary">
                    How it Works
                </Button>
                <Button href="#team" size="large" color="secondary">
                    Team
                </Button>
                <Button href="#contact" size="large" color="secondary">
                    Contact
                </Button>
            </div>
            <Button
                sx={{ borderRadius: "1.5rem" }}
                href="#raman_net"
                size="large"
                variant="contained"
            >
                TRY RamanNet
            </Button>
        </div>
    );
}
